<script lang="ts">
  import { page } from '$app/state';
  import { lettersToBoard } from '~/board/utils';
  import BoardTile from '../../board/Tile.svelte';

  const board = lettersToBoard([['X'], ['Z'], ['G']], page.params.mode);
</script>

<div class="container">
  <div class="letters">
    {#each board.flat() as tile}
      <BoardTile
        tile={{
          ...tile,
          points: -tile.points,
        }}
        size="small"
      />
    {/each}
  </div>
  <div class="penalty">
    -{board.flat().reduce((s, t) => s + t.points, 0)} swaps
  </div>
</div>

<style lang="scss">
  .container {
    display: flex;
    flex-direction: row;
    align-items: center;
    .penalty {
      font-size: 1.25rem;
      margin-left: 1em;
    }
  }
  .letters {
    display: grid;
    grid-auto-flow: column;
    gap: 0.25em;
  }
</style>
